/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CoursefinancialCoursefinancialidLangsId200,
  GetApiV1CoursefinancialCoursefinancialidLangsId401,
  GetApiV1CoursefinancialCoursefinancialidLangsId404,
  GetApiV1CoursefinancialCoursefinancialidLangsId500,
  GetApiV1CoursefinancialCoursefinancialidLangsIdPathParams,
  GetApiV1CoursefinancialCoursefinancialidLangsIdQueryResponse,
} from "../../types/courseFinancialLangsController/GetApiV1CoursefinancialCoursefinancialidLangsId.ts";
import { courseFinancialLangViewModelSchema } from "../courseFinancialLangViewModelSchema.ts";

export const getApiV1CoursefinancialCoursefinancialidLangsIdPathParamsSchema =
  z.object({
    courseFinancialId: z.coerce.number().int(),
    id: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidLangsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CoursefinancialCoursefinancialidLangsId200Schema = z.lazy(
  () => courseFinancialLangViewModelSchema,
) as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidLangsId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CoursefinancialCoursefinancialidLangsId401Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CoursefinancialCoursefinancialidLangsId404Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CoursefinancialCoursefinancialidLangsId500Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidLangsId500>;

export const getApiV1CoursefinancialCoursefinancialidLangsIdQueryResponseSchema =
  z.lazy(
    () => getApiV1CoursefinancialCoursefinancialidLangsId200Schema,
  ) as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidLangsIdQueryResponse>;
